import { FormExtractorService } from "../../../../shared/services/form-extractor.service";
import { LogService } from "../../../../shared/services/log.service";
import { Validator } from "../../../../shared/services/validator";
import { RadioCheckBoxEnum } from "../../../common/radio.checkbox.enums";
import { CTRL_NAME_EXTRACTOR } from "../../ctrl.name.extractor";

export class CTRL_120 implements Validator {

    public static id = 'CTRL_120';
    private message = 'error.ctr_120';


    public LOG: LogService = new LogService(CTRL_120);
    public formExtractorService: FormExtractorService = new FormExtractorService();


    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_120.id + '_');
        const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const organismeAcheteurPublicNameWithStepId = ctrlMap.get(ctrl.value.rgCtrls.organismeAcheteurPublic);
                const adrPouvoirAdjudicateurOuiNonWithStepId = ctrlMap.get(ctrl.value.rgCtrls.adrPouvoirAdjudicateurOuiNon);
                const organismeAcheteurPublicCtrl = form.controls[organismeAcheteurPublicNameWithStepId];
                const adrPouvoirAdjudicateurOuiNonCtrl = form.controls[adrPouvoirAdjudicateurOuiNonWithStepId];

                if (adrPouvoirAdjudicateurOuiNonCtrl?.value !== null && (organismeAcheteurPublicCtrl.value === '' || organismeAcheteurPublicCtrl.value === null)) {
                     // placer le message d'erreur
                     form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
